import { render, staticRenderFns } from "./AdminActivityTable.vue?vue&type=template&id=7f409084"
import script from "./AdminActivityTable.vue?vue&type=script&lang=js"
export * from "./AdminActivityTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports